export default "__VITE_ASSET__3ecd9089__"